export default __webpack_public_path__ + "static/media/generic.747a1762.jpg";